import { UseGuardStepHook } from "@/hooks/useGuardStep";
import { BuildSteps } from "@/types/flows";
import { useGuardSetupStep } from "./useGuardSetupStep";

export const useGuardUpload: UseGuardStepHook = () => useGuardSetupStep(BuildSteps.UPLOAD);
